import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { BASE_FONT_SIZE_PX } from '../../constants';
import { MyPureComponent } from '../../lib/react';
import s from './typography.css';

class Text extends MyPureComponent {
  constructor(props) {
    super(props);

    this.config = {
      component: 'p',
    };
  }

  render() {
    const Component = this.config.component;
    const { className, ...otherProps } = this.props;

    return (
      <Component
        className={cs(s[this.config.className], { [className]: className })}
        {...otherProps}
      >
        {this.props.children}
      </Component>
    );
  }
}

class Header extends Text {}

class Label extends Text {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'span',
    };
  }
}

class Paragraph extends Text {}

class H1Comp extends Header {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'h1',
      className: 'H1',
    };
  }
}
export const H1 = withStyles(s)(H1Comp);

class H2Comp extends Header {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'h2',
      className: 'H2',
    };
  }
}
export const H2 = withStyles(s)(H2Comp);

class H3Comp extends Header {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'h3',
      className: 'H3',
    };
  }
}
export const H3 = withStyles(s)(H3Comp);

class H4Comp extends Header {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'h4',
      className: 'H4',
    };
  }
}
export const H4 = withStyles(s)(H4Comp);

class H5Comp extends Header {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'h5',
      className: 'H5',
    };
  }
}
export const H5 = withStyles(s)(H5Comp);

class H6Comp extends Header {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      component: 'h6',
      className: 'H6',
    };
  }
}
export const H6 = withStyles(s)(H6Comp);

class T1Comp extends H1Comp {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'T1',
    };
  }
}
export const T1 = withStyles(s)(T1Comp);

class T2Comp extends H2Comp {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'T2',
    };
  }
}
export const T2 = withStyles(s)(T2Comp);

class L1Comp extends Label {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'L1',
    };
  }
}
export const L1 = withStyles(s)(L1Comp);

class L2Comp extends Label {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'L2',
    };
  }
}
export const L2 = withStyles(s)(L2Comp);

class L2RComp extends L2Comp {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'L2R',
    };
  }
}
export const L2R = withStyles(s)(L2RComp);

class L3Comp extends Label {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'L3',
    };
  }
}
export const L3 = withStyles(s)(L3Comp);

class L4Comp extends Label {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'L4',
    };
  }
}
export const L4 = withStyles(s)(L4Comp);

class L4RComp extends L4Comp {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'L4R',
    };
  }
}
export const L4R = withStyles(s)(L4RComp);

class P1Comp extends Paragraph {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'P1',
    };
  }
}
export const P1 = withStyles(s)(P1Comp);

class P1RComp extends P1Comp {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'P1R',
    };
  }
}
export const P1R = withStyles(s)(P1RComp);

class P2Comp extends Paragraph {
  constructor(props) {
    super(props);

    this.config = {
      ...this.config,
      className: 'P2',
    };
  }
}
export const P2 = withStyles(s)(P2Comp);



// WEBPACK FOOTER //
// ./src/components/Typography/Typography.js